import {
  HttpClient,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Job,
  MasterPlan,
  Plan,
} from 'master-locations-library/master-locations-library/src/lib/core/domain/models/master-plan';
import { PlanningPortalRepository } from 'master-locations-library/master-locations-library/src/lib/core/repositories';
import { Observable, catchError, map, mergeMap, reduce } from 'rxjs';
import {
  BindLocationWithJobRequest,
  GetPlansByMasterPlanAndLocationIdRequest,
  GetPlansByMasterPlanAndSegmentRequest,
  MasterPlanByLocationProductIdRequest,
  MasterPlansRequest,
} from 'master-locations-library/master-locations-library/src/lib/core/domain/requests';
import { BaseResponse } from 'master-locations-library/master-locations-library/src/lib/core/domain/models';
import {
  JobWebEntity,
  JobWebEntityyMapper,
  MasterPlanWebEntity,
  MasterPlanWebEntityMapper,
  PlanWebEntity,
  PlanWebEntityMapper,
} from './entities';
import { PlanningPortalApiUrl } from './planning-portal-api-urls';
import { PlanningPortalConstants } from '../../../shared/application-constants/planning-portal-constants';
import { injectEnvironment } from 'master-locations-library/master-locations-library/src/lib/core/environments/environment.token';

@Injectable()
export class PlanningPortalWebRepository extends PlanningPortalRepository {
  private headers: HttpHeaders | undefined;
  environment = injectEnvironment();

  constructor(private httpClient: HttpClient) {
    super();
  }
  GetMasterPlanForMLS(segment: MasterPlansRequest): Observable<MasterPlan[]> {
    const mapper = new MasterPlanWebEntityMapper();
    return this.httpClient
      .post<BaseResponse<MasterPlanWebEntity[]>>(
        `${this.environment.planningPortalUrl}${PlanningPortalApiUrl.GetMasterPlanForMLS}`,
        segment,
        { headers: { ApiKey: PlanningPortalConstants.API_KEY_VALUE } }
      )
      .pipe(
        mergeMap((response) => response.result),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(map(mapper.mapFrom))
      .pipe(
        reduce((items: MasterPlan[], item: MasterPlan) => [...items, item], [])
      );
  }
  getMasterPlanByLocationIdAndProductId(
    request: MasterPlanByLocationProductIdRequest
  ): Observable<MasterPlan[]> {
    const mapper = new MasterPlanWebEntityMapper();
    return this.httpClient
      .post<BaseResponse<MasterPlanWebEntity[]>>(
        `${this.environment.planningPortalUrl}${PlanningPortalApiUrl.GetMasterPlanByLocationAndProduct}`,
        request,
        { headers: { ApiKey: PlanningPortalConstants.API_KEY_VALUE } }
      )
      .pipe(
        mergeMap((response) => response.result),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(map(mapper.mapFrom))
      .pipe(
        reduce((items: MasterPlan[], item: MasterPlan) => [...items, item], [])
      );
  }

  addLocationWithJob(
    request: BindLocationWithJobRequest[]
  ): Observable<boolean> {
    return this.httpClient
      .post<BaseResponse<string>>(
        `${this.environment.planningPortalUrl}${PlanningPortalApiUrl.BindLocationWithJobFromMls}`,
        request,
        { headers: { ApiKey: PlanningPortalConstants.API_KEY_VALUE } }
      )
      .pipe(
        map((response) => response.successful),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      );
  }

  GetPlansByMasterPlanAndSegment(
    request: GetPlansByMasterPlanAndSegmentRequest
  ): Observable<Job[]> {
    const mapper = new JobWebEntityyMapper();
    return this.httpClient
      .post<BaseResponse<JobWebEntity[]>>(
        `${this.environment.planningPortalUrl}${PlanningPortalApiUrl.GetPlansByMasterPlanAndSegment}`,
        request,
        { headers: { ApiKey: PlanningPortalConstants.API_KEY_VALUE } }
      )
      .pipe(
        mergeMap((response) => response.result),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(map(mapper.mapFrom))
      .pipe(reduce((items: Job[], item: Job) => [...items, item], []));
  }
  GetPlansByMasterPlanAndLocationId(
    request: GetPlansByMasterPlanAndLocationIdRequest
  ): Observable<Job[]> {
    const mapper = new JobWebEntityyMapper();
    return this.httpClient
      .post<BaseResponse<JobWebEntity[]>>(
        `${this.environment.planningPortalUrl}${PlanningPortalApiUrl.GetPlansByMasterPlanAndLocationId}`,
        request,
        { headers: { ApiKey: PlanningPortalConstants.API_KEY_VALUE } }
      )
      .pipe(
        mergeMap((response) => response.result),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      )
      .pipe(map(mapper.mapFrom))
      .pipe(reduce((items: Job[], item: Job) => [...items, item], []));
  }
}
